import React, { lazy } from "react";
import { Redirect } from "react-router-dom";
import ExampleLayout from "../../layouts/ExampleLayout";
import {
  KonfigurasiAdminDspTypeRevenue,
  KonfigurasiAdminDspTypeRevenueAdd,
  KonfigurasiAdminDspTypeRevenueEdit,
  KonfigurasiAdminDspSftpConfiguration,
  DashboardAssoc,
  KonfigurasiAdminAktifitas,
  BillingKonfigurasi,
  KonfigurasiAdminPajak,
  KonfigurasiAdminRoleUser,
  FormRole,
  KonfigurasiAdminSistem,
  KonfigurasiAdminTemplateNotifikasi,
  KonfigurasiAdminUnclaimOpenPeriod,
  KonfigurasiAdminMessage,
  KonfigurasiAdminMessageEdit,
  KonfigurasiAdminMessageAdd,
  KonfigurasiAdminAnnouncementManagement,
  KonfigurasiAdminAnnouncementManagementDetail,
  KonfigurasiAdminAnnouncementManagementAddOrEdit,
  DetailPreviewAnnouncementManagement,
  KonfigurasiAdminEmailNotification,
  MasterAdminBank,
  MasterAdminBankTambah,
  MasterAdminBankUbah,
  MasterAdminPublisher,
  MasterAdminUser,
  MasterAdminEditUser,
  MasterAdminTambahUser,
  MasterAdminLagu,
  MasterAdminLaguEdit,
  MasterAdminLaguTambah,
  MasterAdminPencipta,
  MasterAdminPenciptaEdit,
  MasterAdminUserPencipta,
  MasterAdminUserPublisher,
  MasterAdminCurrency,
  ManajemenWebAdmin,
  PreviewManajemenWebAdmin,
  ReviewLaguAssoc,
  DetailReviewLaguAssoc,
  Billing,
  BillingDsp,
  BillingDetail,
  MasterAdminDsp,
  FormParameterDsp,
  FormParameterPublisher,
  MasterAdminTerritory,
  MasterAdminSociety,
  FormParameterSociety,
  MasterAdminUserSociety,
  PrintReportDetailReviewAssoc,
  PrintReportReviewAssoc,
  MasterAssociation,
  SongUnclaim,
  FormTax,
  MasterCountry,
  MasterRevenueType,
  ReportProcess,
  AppManagement,
  AdminPotentialClaim,
  AdminDetailPotentialClaimLog,
  PublisherUploadDirectory,
} from "pages/Admin";

// =========== Composer Page page Views =============//

import {
  ProfilePencipta,
  PermintaanPembayaran,
  AjukanPembayaran,
  DashboardPencipta,
  DetailLaguPencipta,
  KontrakListPencipta,
  KontrakListDetailPencipta,
} from "pages/Pencipta";

import AdminLandingPage from "../../pages/AdminLandingPage";

import {
  AdvancedPageFinance,
  AddAdvancedFinance,
  DetailAdvancedFinance,
  PrintPdfAdvancedPage,
} from "pages/Finance";

import PdfReader from "../../pages/LandingPage/PdfReader";
import ManajemenWeb from "../../pages/Publisher/ManajemenWeb";
import DetailDSP from "../../pages/Publisher/Master/PublisherDsp/detail";
import ReportView from "../../pages/Publisher/Report";
import DetailReportView from "../../pages/Publisher/Report/DetailReport";
import AuthLayout from "../../layouts/Auth";
import DashboardAdminLayout from "../../layouts/DashboardAdmin";
import ErrorLayout from "../../layouts/Error";
import NotificationPage from "../../pages/NotificationPage";
import DetailNotification from "../../pages/NotificationPage/Detail";

// =========== Landing page Views =============//

import {
  About,
  Contact,
  Blog,
  Partner,
  DetailBlog,
  DetailPartner,
} from "pages/MpisNewLandingPage";

import LoginAdminLanding from "../../pages/LandingPage/LoginAdmin/LoginAdmin";
import BeritaDetailView from "../../pages/LandingPage/Berita/DetailBerita";
import DetailLagu from "../../pages/LandingPage/DetailLagu/DetailLagu";
import LoginCaris from "../../pages/LandingPage/LoginCaris/LoginCaris";

import NewPassword from "../../pages/LandingPage/NewPassword/NewPassword";
import RedirectPage from "../../pages/RedirectPage";
import ChangePassword from "../../pages/changePassword";

import NewsAds from "../../pages/Publisher/BeritaIklanPublisher";
import FormNewsAds from "../../pages/Publisher/BeritaIklanPublisher/FormNewsAds";
import PreviewNewsAds from "../../pages/Publisher/BeritaIklanPublisher/PreviewNewsAds";
import DetailNewsAds from "../../pages/Publisher/BeritaIklanPublisher/DetailNewsAds";

import DashboardPublisher from "../../pages/Publisher/Dashboard";
import PrintReportPage from "../../pages/Publisher/Dashboard/PrintReportPage";

import {
  PersonalisasiPublisher,
  CostType,
  PembayaranPublisher,
  OriginalPublisherPublisher,
  OriginalPublisherV2Publisher,
  AktifitasPublisher,
  TambahCostType,
  EditCostType,
  SubReporting,
  DetailSubReporting,
  SubReportingApproval,
} from "pages/Publisher/KonfigurasiPublisher";

import {
  KontrakPublisher,
  DetailKontrakPublisher,
  KontrakPublisherTambah,
} from "pages/Publisher";

import ProfilePublisher from "../../pages/Publisher/Profile";
import MasterPublisherPencipta from "../../pages/Publisher/Master/Pencipta";
import FormParameterComposer from "../../pages/Publisher/Master/Pencipta/FormParameterComposer";
import MasterPublisherPerformer from "../../pages/Publisher/Master/Performer";
import FormParameterPerformer from "../../pages/Publisher/Master/Performer/FormParameterPerformer";
import MasterPublisherUser from "../../pages/Publisher/Master/User";
import MasterPublisherLagu from "../../pages/Publisher/Master/Lagu";
import MasterPublisherLaguEdit from "../../pages/Publisher/Master/Lagu/FormParameterSong";
import MasterPublisherLaguTambah from "../../pages/Publisher/Master/Lagu/FormParameterSong";
import MasterPublisherDsp from "../../pages/Publisher/Master/PublisherDsp";

import ReviewLagu from "../../pages/Publisher/ReviewLagu";
import DetailReviewLagu from "../../pages/Publisher/ReviewLagu/DetailReviewLagu";

import PreviewAboutUs from "../../pages/Publisher/ManajemenWeb/PreviewAboutUs";
import Otp from "../../pages/LandingPage/Otp/Otp";

import PrintReportDetailReview from "../../pages/Publisher/ReviewLagu/DetailReviewLagu/PrintReportDetailReview";
import PrintReportReview from "../../pages/Publisher/ReviewLagu/PrintReportReview";
import InvitationPassword from "../../pages/InvitationPassword/InvitationPassword";

import PrivacyPolicy from "../../pages/LandingPage/PrivacyPolicy";

import ClientClassification from "../../pages/Publisher/Master/ClientClassification";
import DoubleClaim from "../../pages/Publisher/SongClaim/DoubleClaim";
import OwnershipConflict from "../../pages/Publisher/SongClaim/OwnershipConflict";
import SongUnclaimPublisher from "../../pages/Publisher/SongClaim/SongUnclaim";
import UnclaimMonitoring from "../../pages/Publisher/SongClaim/UnclaimMonitoring";
import DetailUnclaimMonitoring from "../../pages/Publisher/SongClaim/UnclaimMonitoring/DetailUnclaimMonitoring";
import PotentialClaim from "../../pages/Publisher/PotentialClaim/PotentialClaim";
import PotentialClaimLog from "../../pages/Publisher/PotentialClaim/PotentialClaimLog";
import DetailPotentialClaimLog from "../../pages/Publisher/PotentialClaim/PotentialClaimLog/DetailPotentialClaimLog";
import ExchangesRate from "../../pages/Publisher/ExchangesRate";
import ViewExRate from "../../pages/Publisher/ExchangesRate/ViewExRate/ViewExRate";
import UploadMonitoring from "../../pages/Publisher/UploadMonitoring";
import DetailMonitor from "../../pages/Publisher/UploadMonitoring/DetailMonitor";
import InitCataloguePage from "../../pages/InitCatalogue";
import DownloadMonitoring from "../../pages/Publisher/DownloadMonitoring";
import DownloadCCID from "../../pages/Publisher/DownloadCCID";
import GenerateCCID from "../../pages/Publisher/CCID/GenerateCCID";
import UploadCCID from "../../pages/Publisher/CCID/UploadCCID";

const routesUsed = [
  {
    path: "/",
    exact: true,
    component: LoginCaris,
  },
  {
    path: "/partner",
    exact: true,
    isAuth: false,
    component: Partner,
  },
  {
    path: "/partner/:id",
    exact: true,
    isAuth: false,
    component: DetailPartner,
  },
  {
    path: "/partner/:id",
    exact: true,
    isAuth: false,
    component: DetailPartner,
  },
  {
    path: "/about",
    exact: true,
    isAuth: false,
    component: About,
  },
  {
    path: "/blog",
    exact: true,
    isAuth: false,
    component: Blog,
  },
  {
    path: "/blog/:id",
    exact: true,
    isAuth: false,
    component: DetailBlog,
  },
  {
    path: "/contact",
    exact: true,
    isAuth: false,
    component: Contact,
  },
  {
    path: "/errors",
    component: ErrorLayout,
    routes: [
      {
        path: "/errors/error-401",
        exact: true,
        component: lazy(() => import("../../views/Error401")),
      },
      {
        path: "/errors/error-404",
        exact: true,
        component: lazy(() => import("../../views/Error404")),
      },
      {
        path: "/errors/error-500",
        exact: true,
        component: lazy(() => import("../../views/Error500")),
      },
      {
        component: () => <Redirect to="/errors/error-404" />,
      },
    ],
  },
  {
    path: "/redirect/:token",
    exact: true,
    component: RedirectPage,
  },
  {
    path: "/otp",
    exact: true,
    isAuth: false,
    component: Otp,
  },
  {
    path: "/login",
    exact: true,
    isAuth: false,
    component: LoginCaris,
  },
  {
    path: "/resource/info",
    exact: true,
    isAuth: false,
    component: PdfReader,
  },
  {
    path: "/admin-login",
    exact: true,
    isAuth: false,
    component: LoginAdminLanding,
  },
  {
    path: "/privacy-policy",
    exact: true,
    isAuth: false,
    component: PrivacyPolicy,
  },
  {
    path: "/new-password/:token",
    exact: true,
    component: NewPassword,
  },
  {
    path: "/invitation/password/:token",
    exact: true,
    isAuth: false,
    component: InvitationPassword,
  },
  {
    path: "/artikel/detail/:id",
    exact: true,
    isAuth: false,
    component: BeritaDetailView,
  },
  {
    path: "/detail-lagu",
    exact: true,
    isAuth: false,
    component: DetailLagu,
  },

  {
    path: "/auth",
    component: AuthLayout,
    routes: [
      {
        path: "/auth/login",
        exact: true,
        component: lazy(() => import("../../views/Login")),
      },
      {
        path: "/auth/register",
        exact: true,
        component: lazy(() => import("../../views/Register")),
      },
      {
        component: () => <Redirect to="/errors/error-404" />,
      },
    ],
  },
  {
    path: "/example",
    component: ExampleLayout,
    routes: [
      {
        path: "/example/documentation",
        exact: true,
        role: ["publisher"],
        component: () => {
          return <div>vvv</div>;
        },
      },
    ],
  },
  {
    path: "/admin",
    component: DashboardAdminLayout,
    routes: [
      {
        path: "/admin/dashboard-association",
        exact: true,
        role: ["publisher"],
        component: DashboardAssoc,
      },
      {
        path: "/admin/dashboard",
        exact: true,
        role: ["publisher", "society", "association"],
        component: DashboardPublisher,
      },
      {
        path: "/admin/dashboard/print-report",
        exact: true,
        component: PrintReportPage,
        role: ["publisher", "admin", "society", "association"],
      },
      {
        path: "/admin/billing/publisher",
        exact: true,
        component: Billing,
        role: ["publisher", "admin"],
      },
      {
        path: "/admin/billing/dsp",
        exact: true,
        component: BillingDsp,
        role: ["publisher", "admin"],
      },
      {
        path: "/admin/billing/detail/:id",
        exact: true,
        component: BillingDetail,
        role: ["publisher", "admin"],
      },
      {
        path: "/admin/profile",
        exact: true,
        component: ProfilePublisher,
        role: ["publisher", "admin", "society", "association"],
      },
      {
        path: "/admin/berita-publisher",
        exact: true,
        component: NewsAds,
        role: ["publisher", "admin"],
      },
      {
        path: "/admin/berita-publisher/:id",
        exact: true,
        component: DetailNewsAds,
      },
      {
        path: "/admin/notifikasi",
        exact: true,
        component: NotificationPage,
      },
      {
        path: "/admin/notifikasi/:id",
        exact: true,
        component: DetailNotification,
      },
      {
        path: "/admin/berita-publisher/edit/preview",
        exact: true,
        component: PreviewNewsAds,
      },
      {
        path: "/admin/berita-publisher/edit/:id",
        exact: true,
        component: FormNewsAds,
      },
      {
        path: "/admin/berita-publisher/tambah",
        exact: true,
        component: FormNewsAds,
      },
      {
        path: "/admin/berita-publisher/tambah/preview",
        exact: true,
        component: PreviewNewsAds,
      },
      {
        path: "/admin/advance",
        exact: true,
        component: AdvancedPageFinance,
      },
      {
        path: "/admin/advance/add",
        exact: true,
        component: AddAdvancedFinance,
      },
      {
        path: "/admin/advance/:id",
        exact: true,
        component: DetailAdvancedFinance,
      },
      {
        path: "/admin/advanced/print-as-pdf/:id",
        exact: true,
        component: PrintPdfAdvancedPage,
      },
      {
        path: "/admin/dsrf/download-dsrf",
        exact: true,
        component: ReportProcess,
        role: ["publisher", "admin"],
      },
      {
        path: "/admin/dsrf/report-process",
        exact: true,
        component: ReportProcess,
        role: ["publisher", "admin"],
      },
      {
        path: "/admin/dsrf/process-monitoring",
        exact: true,
        component: ReportProcess,
        role: ["publisher", "admin"],
      },
      {
        path: "/admin/dsrf/potential-claim",
        exact: true,
        component: ReportProcess,
        role: ["publisher", "admin"],
      },
      {
        path: "/admin/dsrf/potential-claim-matching",
        exact: true,
        component: ReportProcess,
        role: ["publisher", "admin"],
      },
      {
        path: "/admin/dsrf/matching-2",
        exact: true,
        component: ReportProcess,
        role: ["publisher", "admin"],
      },
      {
        path: "/admin/dsrf/dsrf-matching",
        exact: true,
        component: ReportProcess,
        role: ["publisher", "admin"],
      },
      {
        path: "/admin/dsrf/dsrf-matching-2",
        exact: true,
        component: ReportProcess,
        role: ["publisher", "admin"],
      },
      {
        path: "/admin/konfigurasi/exchange-rate",
        exact: true,
        component: ExchangesRate,
        role: ["publisher", "admin"],
      },
      {
        path: "/admin/konfigurasi/exchange-rate/view/:id/:currency",
        exact: true,
        component: ViewExRate,
        role: ["publisher", "admin"],
      },
      {
        path: "/admin/song-unclaim",
        exact: true,
        component: SongUnclaim,
      },
      {
        path: "/admin/publisher/double-claim",
        exact: true,
        component: DoubleClaim,
      },
      {
        path: "/admin/ownership-conflict",
        exact: true,
        component: OwnershipConflict,
      },
      {
        path: "/admin/publisher/ownership-conflict",
        exact: true,
        component: OwnershipConflict,
      },
      {
        path: "/admin/publisher/song-unclaim",
        exact: true,
        component: SongUnclaimPublisher,
      },
      {
        path: "/admin/publisher/unclaim-monitoring",
        exact: true,
        component: UnclaimMonitoring,
      },
      {
        path: "/admin/publisher/unclaim-monitoring/:id",
        exact: true,
        component: DetailUnclaimMonitoring,
      },
      {
        path: "/admin/unclaim-monitoring",
        exact: true,
        component: UnclaimMonitoring,
      },
      {
        path: "/admin/unclaim-monitoring/:id",
        exact: true,
        component: DetailUnclaimMonitoring,
      },

      {
        path: "/admin/potential-claim",
        exact: true,
        component: AdminPotentialClaim,
      },
      {
        path: "/admin/potential-claim/log",
        exact: true,
        component: AdminPotentialClaim,
      },
      {
        path: "/admin/potential-claim/log/:id",
        exact: true,
        component: AdminDetailPotentialClaimLog,
      },
      {
        path: "/admin/publisher/potential-claim",
        exact: true,
        component: PotentialClaim,
      },
      {
        path: "/admin/publisher/potential-claim-log",
        exact: true,
        component: PotentialClaimLog,
      },
      {
        path: "/admin/publisher/potential-claim-log/:id",
        exact: true,
        component: DetailPotentialClaimLog,
      },
      {
        path: "/admin/parameter/pencipta",
        exact: true,
        component: MasterPublisherPencipta,
      },
      {
        path: "/admin/parameter/pencipta/tambah",
        exact: true,
        component: FormParameterComposer,
      },
      {
        path: "/admin/parameter/pencipta/edit/:id",
        exact: true,
        component: FormParameterComposer,
      },
      {
        path: "/admin/parameter/client-classification",
        exact: true,
        component: ClientClassification,
      },
      {
        path: "/admin/parameter/lagu",
        exact: true,
        component: MasterPublisherLagu,
      },
      {
        path: "/admin/parameter/lagu/tambah",
        exact: true,
        component: MasterPublisherLaguTambah,
      },
      {
        path: "/admin/parameter/lagu/edit/:id",
        exact: true,
        component: MasterPublisherLaguEdit,
      },
      {
        path: "/admin/parameter/dsp",
        exact: true,
        component: MasterPublisherDsp,
      },
      {
        path: "/admin/parameter/dsp/detail/:id",
        exact: true,
        component: DetailDSP,
      },
      {
        path: "/admin/parameter/performer",
        exact: true,
        component: MasterPublisherPerformer,
      },
      {
        path: "/admin/parameter/performer/tambah",
        exact: true,
        component: FormParameterPerformer,
      },
      {
        path: "/admin/parameter/performer/edit/:id",
        exact: true,
        component: FormParameterPerformer,
      },
      {
        path: "/admin/parameter/user",
        exact: true,
        component: MasterPublisherUser,
      },
      {
        path: "/admin/konfigurasi/personalisasi",
        exact: true,
        component: PersonalisasiPublisher,
      },
      {
        path: "/admin/konfigurasi/cost-type",
        exact: true,
        component: CostType,
      },
      {
        path: "/admin/konfigurasi/add-cost-type",
        exact: true,
        component: TambahCostType,
      },
      {
        path: "/admin/konfigurasi/edit-cost-type/:id",
        exact: true,
        component: EditCostType,
      },
      {
        path: "/admin/konfigurasi/pembayaran",
        exact: true,
        component: PembayaranPublisher,
      },
      {
        path: "/admin/konfigurasi/original-publisher",
        exact: true,
        component: OriginalPublisherPublisher,
      },
      {
        path: "/admin/konfigurasi/original-publisher-v2",
        exact: true,
        component: OriginalPublisherV2Publisher,
      },
      {
        path: "/admin/konfigurasi/aktifitas",
        exact: true,
        component: AktifitasPublisher,
      },
      {
        path: "/admin/konfigurasi/sub-reporting",
        exact: true,
        component: SubReporting,
      },
      {
        path: "/admin/konfigurasi/sub-reporting/:id",
        exact: true,
        component: DetailSubReporting,
      },
      {
        path: "/admin/konfigurasi/sub-reporting-approval",
        exact: true,
        component: SubReportingApproval,
      },
      {
        path: "/admin/kontrak",
        exact: true,
        component: KontrakPublisher,
      },
      {
        path: "/admin/kontrak/detail/:id",
        exact: true,
        component: DetailKontrakPublisher,
      },
      {
        path: "/admin/kontrak/tambah",
        exact: true,
        component: KontrakPublisherTambah,
      },
      {
        path: "/admin/review-lagu-association",
        exact: true,
        component: ReviewLaguAssoc,
      },
      {
        path: "/admin/reports",
        exact: true,
        component: ReportView,
      },
      {
        path: "/admin/reports/:id",
        exact: true,
        component: DetailReportView,
      },
      {
        path: "/admin/review-lagu-association/print-report",
        exact: true,
        component: PrintReportReviewAssoc,
      },
      {
        path: "/admin/review-lagu-association/:id",
        exact: true,
        component: DetailReviewLaguAssoc,
      },
      {
        path: "/admin/review-lagu-association/detail/print-report",
        exact: true,
        component: PrintReportDetailReviewAssoc,
      },
      {
        path: "/admin/review-lagu",
        exact: true,
        role: ["publisher", "admin", "society", "association"],
        component: ReviewLagu,
      },
      {
        path: "/admin/review-lagu/print-report",
        exact: true,
        component: PrintReportReview,
        role: ["publisher", "admin", "society", "association"],
      },
      {
        path: "/admin/review-lagu/:id",
        exact: true,
        role: ["publisher", "admin", "society", "association"],
        component: DetailReviewLagu,
      },
      {
        path: "/admin/review-lagu/detail/print-report",
        exact: true,
        role: ["publisher", "admin", "society", "association"],
        component: PrintReportDetailReview,
      },
      {
        path: "/admin/change-password",
        exact: true,
        component: ChangePassword,
      },
      {
        path: "/admin/konfigurasi/sistem",
        exact: true,
        component: props => {
          return <KonfigurasiAdminSistem {...props} mustLoggedIn={true} />;
        },
      },
      {
        path: "/admin/konfigurasi/unclaim-open-period",
        exact: true,
        component: props => {
          return (
            <KonfigurasiAdminUnclaimOpenPeriod {...props} mustLoggedIn={true} />
          );
        },
      },
      {
        path: "/admin/konfigurasi/publisher-directory",
        exact: true,
        component: PublisherUploadDirectory,
      },
      {
        path: "/admin/konfigurasi/template-notifikasi",
        exact: true,
        component: KonfigurasiAdminTemplateNotifikasi,
      },
      {
        path: "/admin/konfigurasi/message",
        exact: true,
        component: KonfigurasiAdminMessage,
      },
      {
        path: "/admin/konfigurasi/message/add",
        exact: true,
        component: KonfigurasiAdminMessageAdd,
      },
      {
        path: "/admin/konfigurasi/message/edit/:id",
        exact: true,
        component: KonfigurasiAdminMessageEdit,
      },
      {
        path: "/admin/konfigurasi/pajak",
        exact: true,
        component: KonfigurasiAdminPajak,
      },
      {
        path: "/admin/konfigurasi/pajak/add",
        exact: true,
        component: FormTax,
      },
      {
        path: "/admin/konfigurasi/pajak/edit/:id",
        exact: true,
        component: FormTax,
      },
      {
        path: "/admin/konfigurasi/role-user",
        exact: true,
        component: KonfigurasiAdminRoleUser,
      },
      {
        path: "/admin/konfigurasi/role-user/add",
        exact: true,
        component: FormRole,
      },
      {
        path: "/admin/konfigurasi/role-user/edit/:role_id",
        exact: true,
        component: FormRole,
      },
      {
        path: "/admin/konfigurasi/aktifitas-admin",
        exact: true,
        component: KonfigurasiAdminAktifitas,
      },
      {
        path: "/admin/konfigurasi/dsp-type-revenue",
        exact: true,
        component: KonfigurasiAdminDspTypeRevenue,
      },
      {
        path: "/admin/konfigurasi/dsp-type-revenue/add",
        exact: true,
        component: KonfigurasiAdminDspTypeRevenueAdd,
      },
      {
        path: "/admin/konfigurasi/dsp-type-revenue/edit/:id",
        exact: true,
        component: KonfigurasiAdminDspTypeRevenueEdit,
      },
      {
        path: "/admin/konfigurasi/dsp-sftp",
        exact: true,
        component: KonfigurasiAdminDspSftpConfiguration,
      },
      {
        path: "/admin/konfigurasi/billing-configuration",
        exact: true,
        component: BillingKonfigurasi,
      },
      {
        path: "/admin/konfigurasi/announcement-management",
        exact: true,
        component: KonfigurasiAdminAnnouncementManagement,
      },
      {
        path:
          "/admin/konfigurasi/announcement-management/add/:typeAnnouncement",
        exact: true,
        component: KonfigurasiAdminAnnouncementManagementAddOrEdit,
      },
      {
        path: "/admin/konfigurasi/announcement-management/edit/:id",
        exact: true,
        component: KonfigurasiAdminAnnouncementManagementAddOrEdit,
      },
      {
        path:
          "/admin/konfigurasi/announcement-management/edit/:id/:typeAnnouncement",
        exact: true,
        component: KonfigurasiAdminAnnouncementManagementAddOrEdit,
      },
      {
        path: "/admin/konfigurasi/announcement-management/view/:id",
        exact: true,
        component: KonfigurasiAdminAnnouncementManagementDetail,
      },
      {
        path:
          "/admin/konfigurasi/announcement-management/view/:id/:typeAnnouncement",
        exact: true,
        component: KonfigurasiAdminAnnouncementManagementDetail,
      },
      {
        path: "/admin/konfigurasi/announcement-management/view/preview/:id",
        exact: true,
        component: DetailPreviewAnnouncementManagement,
      },
      {
        path: "/admin/konfigurasi/system-email-notification",
        exact: true,
        component: KonfigurasiAdminEmailNotification,
      },
      {
        path: "/admin/parameter/publisher",
        exact: true,
        component: MasterAdminPublisher,
      },
      {
        path: "/admin/parameter/publisher/add",
        exact: true,
        component: FormParameterPublisher,
      },
      {
        path: "/admin/parameter/publisher/:id",
        exact: true,
        component: FormParameterPublisher,
      },
      {
        path: "/admin/parameter/association",
        exact: true,
        component: MasterAssociation,
      },
      {
        path: "/admin/parameter/admin-currency",
        exact: true,
        component: MasterAdminCurrency,
      },
      {
        path: "/admin/parameter/admin-revenue-type",
        exact: true,
        component: MasterRevenueType,
      },
      {
        path: "/admin/parameter/admin-country",
        exact: true,
        component: MasterCountry,
      },
      {
        path: "/admin/parameter/lagu-admin",
        exact: true,
        component: MasterAdminLagu,
      },
      {
        path: "/admin/parameter/lagu-admin/tambah",
        exact: true,
        component: MasterAdminLaguTambah,
      },
      {
        path: "/admin/parameter/lagu-admin/edit/:id",
        exact: true,
        component: MasterAdminLaguEdit,
      },
      {
        path: "/admin/parameter/user-admin",
        exact: true,
        component: MasterAdminUser,
      },
      {
        path: "/admin/parameter/user-admin/tambah",
        exact: true,
        component: MasterAdminTambahUser,
      },
      {
        path: "/admin/parameter/user-admin/edit/:id",
        exact: true,
        component: MasterAdminEditUser,
      },
      {
        path: "/admin/parameter/bank-admin",
        exact: true,
        component: MasterAdminBank,
      },
      {
        path: "/admin/parameter/bank-admin/tambah",
        exact: true,
        component: MasterAdminBankTambah,
      },
      {
        path: "/admin/parameter/bank-admin/ubah/:id",
        exact: true,
        component: MasterAdminBankUbah,
      },
      {
        path: "/admin/parameter/pencipta-admin/:id",
        exact: true,
        component: MasterAdminPenciptaEdit,
      },
      {
        path: "/admin/parameter/pencipta-admin",
        exact: true,
        component: MasterAdminPencipta,
      },
      {
        path: "/admin/parameter/dsp-admin",
        exact: true,
        component: MasterAdminDsp,
      },
      {
        path: "/admin/parameter/dsp-admin/add",
        exact: true,
        component: FormParameterDsp,
      },
      {
        path: "/admin/parameter/dsp-admin/:id",
        exact: true,
        component: FormParameterDsp,
      },
      {
        path: "/admin/parameter/user-publisher",
        exact: true,
        component: MasterAdminUserPublisher,
      },
      {
        path: "/admin/parameter/user-pencipta",
        exact: true,
        component: MasterAdminUserPencipta,
      },
      {
        path: "/admin/parameter/territory",
        exact: true,
        component: MasterAdminTerritory,
      },
      {
        path: "/admin/parameter/society",
        exact: true,
        component: MasterAdminSociety,
      },
      {
        path: "/admin/parameter/society/add",
        exact: true,
        component: FormParameterSociety,
      },
      {
        path: "/admin/parameter/society/edit/:id",
        exact: true,
        component: FormParameterSociety,
      },
      {
        path: "/admin/parameter/user-society",
        exact: true,
        component: MasterAdminUserSociety,
      },
      {
        path: "/admin/berita",
        exact: true,
        component: NewsAds,
      },
      {
        path: "/admin/berita/tambah",
        exact: true,
        component: FormNewsAds,
      },
      {
        path: "/admin/berita/tambah/preview",
        exact: true,
        component: PreviewNewsAds,
      },
      {
        path: "/admin/berita/edit/preview",
        exact: true,
        component: PreviewNewsAds,
      },
      {
        path: "/admin/berita/:id",
        exact: true,
        component: FormNewsAds,
      },
      {
        path: "/admin/finalisasi-berita",
        exact: true,
        component: NewsAds,
      },
      {
        path: "/admin/finalisasi-berita/view/preview",
        exact: true,
        component: PreviewNewsAds,
      },
      {
        path: "/admin/finalisasi-berita/view/:id",
        exact: true,
        component: FormNewsAds,
      },
      {
        path: "/admin/manajemen-web",
        exact: true,
        component: ManajemenWeb,
      },
      {
        path: "/admin/manajemen-web/preview",
        exact: true,
        component: PreviewAboutUs,
      },
      {
        path: "/admin/manajemen-web-admin",
        exact: true,
        component: ManajemenWebAdmin,
      },
      {
        path: "/admin/manajemen-web/preview-admin",
        exact: true,
        component: PreviewManajemenWebAdmin,
      },
      {
        path: "/admin/landing-page",
        exact: true,
        component: AdminLandingPage,
      },
      {
        path: "/admin/upload-monitoring",
        exact: true,
        component: UploadMonitoring,
        role: ["publisher", "admin"],
      },
      {
        path: "/admin/detail-upload-monitoring/:id",
        exact: true,
        component: DetailMonitor,
        role: ["publisher", "admin"],
      },
      {
        path: "/admin/init-catalogue",
        exact: true,
        component: InitCataloguePage,
      },
      {
        path: "/admin/download-monitoring",
        exact: true,
        component: DownloadMonitoring,
        role: ["publisher"],
      },
      {
        path: "/admin/download-ccid",
        exact: true,
        component: DownloadCCID,
      },
      {
        path: "/admin/ccid/download-ccid",
        exact: true,
        component: DownloadCCID,
      },
      {
        path: "/admin/ccid/generate-ccid",
        exact: true,
        component: GenerateCCID,
      },
      {
        path: "/admin/ccid/upload-ccid",
        exact: true,
        component: UploadCCID,
      },
      {
        path: "/admin/dsrf/download-dsrf",
        exact: true,
        component: ReportProcess,
      },
      {
        path: "/admin/dsrf/report-process",
        exact: true,
        component: ReportProcess,
      },
      {
        path: "/admin/dsrf/process-monitoring",
        exact: true,
        component: ReportProcess,
      },
      {
        path: "/admin/report-process",
        exact: true,
        component: () => <Redirect to="/admin/dsrf/download-dsrf" />,
      },
      {
        path: "/admin/app-management",
        exact: true,
        component: AppManagement,
        role: ["publisher", "admin"],
      },
    ],
  },
  {
    path: "/finance",
    component: DashboardAdminLayout,
    routes: [
      {
        path: "/finance/advance",
        exact: true,
        component: AdvancedPageFinance,
      },
      {
        path: "/finance/advance/add",
        exact: true,
        component: AddAdvancedFinance,
      },
      {
        path: "/finance/advanced/print-as-pdf/:id",
        exact: true,
        component: PrintPdfAdvancedPage,
      },
      {
        path: "/finance/advance/:id",
        exact: true,
        component: DetailAdvancedFinance,
      },
    ],
  },
  {
    path: "/pencipta",
    component: DashboardAdminLayout,
    routes: [
      {
        path: "/pencipta/dashboard-pencipta",
        exact: true,
        component: () => <DashboardPencipta roles={["composer"]} />,
      },
      {
        path: "/pencipta/dashboard-pencipta/detail-lagu/:id",
        exact: true,
        role: ["composer"],
        component: DetailLaguPencipta,
      },
      {
        path: "/pencipta/kontrak",
        exact: true,
        role: ["pencipta"],
        component: KontrakListPencipta,
      },
      {
        path: "/pencipta/kontrak/detail-kontrak/:id",
        exact: true,
        component: KontrakListDetailPencipta,
      },
      {
        path: "/pencipta/permintaan-pembayaran",
        exact: true,
        component: PermintaanPembayaran,
      },
      {
        path: "/pencipta/permintaan-pembayaran/ajukan-pembayaran",
        exact: true,
        component: AjukanPembayaran,
      },
      {
        path: "/pencipta/profile-pencipta",
        exact: true,
        component: ProfilePencipta,
        role: ["publisher", "admin", "composer"],
      },
    ],
  },
  {
    path: "/association",
    component: DashboardAdminLayout,
    routes: [
      {
        path: "/association/ownership-conflict",
        exact: true,
        component: OwnershipConflict,
      },
    ],
  },
  {
    component: () => <Redirect to="/errors/error-404" />,
  },
];
const itemRoutes = routesUsed;
export default itemRoutes;
